export const SHARE_MESSAGE = 'Uber Eats Restaurant of the Year 2025 is now live! Vote for your favourite restaurant and they could win £100,000!';
export const SHARE_RAW_HASHTAGS = '#UberEatsAwards #RestaurantOfTheYear #TrailblazersAwards #VoteNow';
export const FB_HASHTAGS = '#UberEatsAwards';
export const TWITTER_HASHTAGS = 'UberEatsAwards, RestaurantOfTheYear, TrailblazersAwards, VoteNow';

